'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _index = require('./index');

var _frFR = require('./locales/themes/fr-FR');

var _frFR2 = _interopRequireDefault(_frFR);

var _enGB = require('./locales/themes/en-GB');

var _enGB2 = _interopRequireDefault(_enGB);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var label = "Themes";
var locales = {
	'fr-FR': _frFR2.default,
	'en-GB': _enGB2.default
};

var Themes = function Themes(dic) {
	var _this = this;

	_classCallCheck(this, Themes);

	this.locale = function (locale) {
		if (!locale) {
			console.error('[' + label + '] No locale defined');
			return new Themes(_this.dictionary);
		}

		var dictionary = _this.dictionary[locale];
		if (!dictionary) {
			console.error('[' + label + '] Cannot find locale ' + locale);
			return new Themes(_this.dictionary);
		}
		return new Themes(dictionary);
	};

	this.exclude = function (ids) {
		if (_this.dictionary['fr-FR'] !== undefined && _this.dictionary['fr-FR'] !== null) {
			// Not yet localized
			console.warn('[' + label + '] Please perform a .locale() before this operation');
			return new Themes(_this.dictionary);
		}

		var dictionary = Object.entries(_this.dictionary).reduce(function (p, _ref) {
			var _ref2 = _slicedToArray(_ref, 2),
			    key = _ref2[0],
			    value = _ref2[1];

			return Object.assign({}, p, ids.indexOf(key) === -1 ? _defineProperty({}, key, value) : null);
		}, {});
		return new Themes(dictionary);
	};

	this.onlyInclude = function (ids) {
		if (_this.dictionary['fr-FR'] !== undefined && _this.dictionary['fr-FR'] !== null) {
			// Not yet localized
			console.warn('[' + label + '] Please perform a .locale() before this operation');
			return new Themes(_this.dictionary);
		}

		var dictionary = Object.entries(_this.dictionary).reduce(function (p, _ref4) {
			var _ref5 = _slicedToArray(_ref4, 2),
			    key = _ref5[0],
			    value = _ref5[1];

			return Object.assign({}, p, ids.indexOf(key) > -1 ? _defineProperty({}, key, value) : null);
		}, {});
		return new Themes(dictionary);
	};

	this.sort = function () {
		if (_this.dictionary['fr-FR'] !== undefined && _this.dictionary['fr-FR'] !== null) {
			// Not yet localized
			console.warn('[' + label + '] For better performance, set .locale() before performing a .sort()');
			var _dictionary = Object.keys(_this.dictionary).reduce(function (p, c) {
				return Object.assign({}, p, _defineProperty({}, c, (0, _index.sorted)({ dictionary: _this.dictionary[c] })));
			}, {});
			return new Themes(_dictionary);
		}

		// already localized
		var dictionary = (0, _index.sorted)({ dictionary: _this.dictionary });
		return new Themes(dictionary);
	};

	this.get = function (which) {
		return which ? _this.one(which) : _this.dictionary;
	};

	this.one = function (which) {
		return _this.dictionary[which];
	};

	this.keys = function () {
		return Object.keys(_this.dictionary);
	};

	this.getAsSelectValues = function () {
		return Object.entries(_this.dictionary).map(function (_ref7) {
			var _ref8 = _slicedToArray(_ref7, 2),
			    key = _ref8[0],
			    value = _ref8[1];

			return { value: key, label: value };
		});
	};

	if (dic) {
		if (dic instanceof Themes) this.dictionary = dic.get();else this.dictionary = dic;
	} else {
		this.dictionary = locales;
	}
};

exports.default = Themes;